/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Context_StageInputs */

const en_task_field_context_stage = /** @type {(inputs: Task_Field_Context_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case stage`)
};

const pt_br2_task_field_context_stage = /** @type {(inputs: Task_Field_Context_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa do caso`)
};

/**
* | output |
* | --- |
* | "Case stage" |
*
* @param {Task_Field_Context_StageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_context_stage = /** @type {((inputs?: Task_Field_Context_StageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Context_StageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_context_stage(inputs)
	return pt_br2_task_field_context_stage(inputs)
});